<template>
  <div class="flex gap-4 px-3 py-2">
    <div class="flex items-center gap-2">
      <i class="fas fa-calendar-alt text-black text-sm"></i>
      <label class="text-sm font-medium text-black pt-2">Période :</label>
    </div>
    <div class="mt-4">
      <BaseInput
        v-model="selectedPeriod"
        type="select"
        :options="periodOptions"
        @update:model-value="handlePeriodChange"
      />  
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { BaseInput } from '@/components'

interface Props {
  modelValue: string
  periodOptions: { value: string; label: string }[]
}

const props = defineProps<Props>()
const emit = defineEmits<{
  'update:modelValue': [value: string]
}>()

const selectedPeriod = ref(props.modelValue)

const handlePeriodChange = (value: string) => {
  emit('update:modelValue', value)
}

watch(() => props.modelValue, (newValue) => {
  selectedPeriod.value = newValue
})
</script>
